import script from "./GrouperBody.vue?vue&type=script&lang=ts&setup=true"
export * from "./GrouperBody.vue?vue&type=script&lang=ts&setup=true"

import "./GrouperBody.vue?vue&type=style&index=0&id=ef5e1ad8&lang=scss"

const __exports__ = script;

export default __exports__